import tw from 'twin.macro';
import styled from 'styled-components';

export const PageWrapper = tw.div`flex justify-between overflow-hidden
bg-white relative font-display`;

// styles relating to the sidebar
export const SideBarWrap = tw.div`w-96 bg-white fixed shadow-cus h-auto
 max-h-screen relative`;

export const SideBarHeadWrap = tw.div`flex bg-adminsecondary text-white pt-6 pb-2 
mb-10 pl-4 items-center`;

export const ProfilePic = tw.img`w-10 h-10 rounded-full`;

export const ProfileTextWrap = tw.div`ml-2 overflow-auto`;

export const ProfileTitle = tw.h2`text-sm`;

export const ProfileName = tw.h4``;

export const ProfileEmail = tw.h6`text-xs`;

export const TabStyle = styled.h4`
  ${({ isActive }: { isActive: boolean }) =>
    isActive ? tw`bg-[#ff9c00] text-white` : tw`text-gray-700`}
  ${tw`text-base cursor-pointer 
my-2 hover:bg-[#ff9c00cc] hover:text-white
transition duration-150 font-medium pl-3 py-3 pr-3`}
`;

export const TabIcon = tw.i`mr-1.5`;
